module.exports = __webpack_public_path__ + "img/import.ef87ccd2.png";